module.exports = [{
      plugin: () => require('../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.sixthreezero.com"},
    },{
      plugin: () => require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"sixthreezero Bike Co.","short_name":"sixthreezero","start_url":"/","background_color":"#FFFFFF","theme_color":"#00C4D1","display":"minimal-ui","icon":"static/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"62de2b7dac7d2a4bcf9ef93f96908de3"},
    },{
      plugin: () => require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/opt/build/repo/src/components/Layout/index.tsx"},
    },{
      plugin: () => require('../node_modules/gatsby-plugin-loadable-components-ssr/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: () => require('../node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://3729c99a253a46309a6807d5766af41f@o1052539.ingest.sentry.io/6036284","environment":"production","enabled":true},
    },{
      plugin: () => require('../node_modules/gatsby-plugin-use-query-params/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: () => require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
